import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredVolatilityHigh = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={71}
    height={26}
    fill="none"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#a)">
      <rect
        width={7.5}
        height={21}
        x={7.5}
        y={22.5}
        fill="url(#b)"
        rx={1}
        transform="rotate(-180 7.5 22.5)"
      />
      <path
        fill="url(#c)"
        d="M10.5 11.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-10Z"
      />
      <rect width={4.5} height={7.636} x={19.5} y={15} fill="url(#d)" rx={1} />
    </g>
    <path
      fill="url(#e)"
      d="M37.677 11.415v2.057h-6.68v-2.057h6.68Zm-5.898-5.212V19h-2.636V6.203h2.636Zm7.779 0V19H36.93V6.203h2.628Zm5.097 0V19h-2.628V6.203h2.628Zm12.613 6.109v5.07c-.2.241-.507.502-.923.783-.416.275-.952.513-1.609.712-.656.2-1.45.299-2.381.299-.827 0-1.58-.135-2.26-.404a4.881 4.881 0 0 1-1.757-1.205c-.486-.527-.861-1.172-1.125-1.933-.264-.768-.396-1.644-.396-2.628v-.8c0-.984.126-1.86.378-2.628.258-.767.624-1.415 1.099-1.942a4.704 4.704 0 0 1 1.696-1.204c.657-.276 1.386-.413 2.189-.413 1.113 0 2.027.181 2.742.544.715.358 1.26.856 1.635 1.495.38.632.615 1.359.703 2.18H54.7a3.27 3.27 0 0 0-.369-1.134 1.908 1.908 0 0 0-.782-.756c-.334-.182-.768-.273-1.301-.273-.44 0-.832.091-1.178.273-.34.175-.627.436-.861.782-.234.346-.413.773-.536 1.283-.123.51-.185 1.102-.185 1.775v.818c0 .668.065 1.26.194 1.775.129.51.319.94.57 1.292.259.346.575.607.95.782.375.176.812.264 1.31.264.416 0 .761-.035 1.037-.105.281-.07.507-.156.677-.255.175-.106.31-.205.404-.299v-2.268h-2.408v-1.88h5.045Zm10.66-.897v2.057H61.25v-2.057h6.68Zm-5.897-5.212V19h-2.636V6.203h2.636Zm7.779 0V19h-2.628V6.203h2.628Z"
    />
    <defs>
      <linearGradient
        id="b"
        x1={17.5}
        x2={-4.878}
        y1={48.75}
        y2={46.8}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E80032" />
        <stop offset={0.8} stopColor="#FAC243" />
        <stop offset={1} stopColor="#FFF347" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={0.9}
        x2={23.8}
        y1={0.75}
        y2={3.813}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E80032" />
        <stop offset={1} stopColor="#FFF347" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={0.75}
        x2={24.745}
        y1={5.25}
        y2={6.577}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E80032" />
        <stop offset={1} stopColor="#FFF347" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={24.692}
        x2={81.92}
        y1={3.792}
        y2={40.334}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E80032" />
        <stop offset={1} stopColor="#FFF347" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredVolatilityHigh)
const IconSvgColouredVolatilityHigh = createIcon(
  ForwardRef,
  'SvgColouredVolatilityHigh',
)
export default IconSvgColouredVolatilityHigh
